import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import i18n from 'cityads-v3/i18n';

import {
  setForm,
  saveForm,
} from 'cityads-v3/actions/welcomeform';

import EmptyResults from 'cityads-v3/components/EmptyResults';
import WaitingButton from 'cityads-v3/components/Buttons/WaitingButton';

import FormControlLabel from '@material-ui/core/FormControlLabel';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import CheckCircleOutlinedIcon from '@material-ui/icons/CheckCircleOutlined';
import Typography from '@material-ui/core/Typography';

import classes from './WelcomeForm.scss';

import {
  WEBMASTER_TYPES,
} from './WelcomeForm';

@connect(state => ({
  form: state.welcomeform.formData,
  isSavingForm: state.welcomeform.isSavingForm,
}))
@withTranslation(['Welcome'], { i18n, wait: !!window })
export default class Step1 extends Component {

  goNext() {
    this.props.dispatch(saveForm('personal_settings'))
      .then(() => {
        this.props.dispatch(setForm({
          data: {},
          page: 2
        }));
      })
    ;
  }

  onTypeChange = (evt, value) => {
    this.props.dispatch(setForm({
      data: {
        webmaster_type: Number(value),
        traffic_type: '',
        traffic_subtypes: [],
        traffic_type_url: '',
      },
      page: 1
    }));
  }

  render() {
    const { t, form, isSavingForm } = this.props;

    return (
      <div>
        <div className={classes.stepContent}>
          <EmptyResults
            className={classes.emptyResultsContainer}
            icon={<CheckCircleOutlinedIcon />}
            emptyText={(
              <div className={classes.welcomeGreetings}>
                {t('description')}
              </div>
            )}
          />
        </div>
        <div className={classes.form}>
          <div className={classes.form__title}>
            {t('step1_title')}
          </div>

          <div className={classes.form__radiogroup}>
            <RadioGroup
              name="personal"
              onChange={this.onTypeChange}
              value={String(form.webmaster_type)}
            >
              {WEBMASTER_TYPES(t).map(item => (
                <FormControlLabel
                  key={item.value}
                  value={String(item.value)}
                  control={<Radio color="primary"/>}
                  label={<div>
                    <Typography>{item.label}</Typography>
                    {String(form.webmaster_type) === String(item.value) && (
                      <Typography color="textSecondary" className={classes.radioDescription}>{item.description}</Typography>
                    )}
                  </div>}
                  classes={{
                    root: classes.FormControlLabelRoot,
                    label: classes.FormControlLabelLabel,
                  }}
                />
              ))}
            </RadioGroup>
          </div>

          <div className={classes.buttons}>
            <WaitingButton
              variant = "contained"
              color   = "primary"
              onClick = {() => this.goNext()}
              waiting = {isSavingForm}
            >
              {t('continue')}
            </WaitingButton>
          </div>
        </div>
      </div>
    );
  }

}
